import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import ArrowDownIcon from "../../assets/img/arrowDownIcon";
import ArrowUpIcon from "../../assets/img/arrowUpIcon";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import LoadingText from "../../components/loadingText/loadingText.component";
import {
  selectNewRequestSuggestionPrice,
  selectNewRequestSuggestionPriceIsLoading,
} from "../../redux/newRequest/newRequest.selectors";
import { SuggestionBoxStyled } from "./suggestionBox.styles";

const SuggestionBox = ({
  selectNewRequestSuggestionPrice,
  selectNewRequestSuggestionPriceIsLoading,
}) => {
  const { from, to, suggested_price, weight } = selectNewRequestSuggestionPrice;

  return (
    <SuggestionBoxStyled>
      <div>
        <div className="font-weight-bold">قیمت پیشنهادی بارنت</div>
        <div className="max-weight d-flex align-items-center justify-content-between">
          <div>حداکثر وزن</div>
          <div>
            {!selectNewRequestSuggestionPriceIsLoading ? (
              weight ? (
                toPersianNum(weight)
              ) : (
                "---"
              )
            ) : (
              <LoadingText className="d-inline-flex" />
            )}
          </div>
        </div>
      </div>
      <div className="d-flex flex-column justify-content-between h-100">
        <div
          className="position-relative font-size--n3"
          style={{
            backgroundColor: "#3E3146",
            borderRadius: "4px",
            padding: "2px",
          }}
        >
          <div className="price-arrow">
            <ArrowUpIcon size="16" color="#ed5565" />
          </div>
          <span>
            {!selectNewRequestSuggestionPriceIsLoading ? (
              to ? (
                toSeperatedNum(toPersianNum(to))
              ) : (
                "---"
              )
            ) : (
              <LoadingText className="d-inline-flex" />
            )}
          </span>
          <span> تومان</span>
        </div>

        <div>
          <span>
            {!selectNewRequestSuggestionPriceIsLoading ? (
              suggested_price ? (
                toSeperatedNum(toPersianNum(suggested_price))
              ) : (
                "---"
              )
            ) : (
              <LoadingText className="d-inline-flex" />
            )}
          </span>
          <span> تومان</span>
        </div>

        <div
          className="position-relative font-size--n3"
          style={{
            borderRadius: "4px",
            backgroundColor: "#2D3E4E",

            padding: "2px",
          }}
        >
          <div className="price-arrow">
            <ArrowDownIcon size="16" color="#48cfad" />
          </div>
          <span>
            {!selectNewRequestSuggestionPriceIsLoading ? (
              from ? (
                toSeperatedNum(toPersianNum(from))
              ) : (
                "---"
              )
            ) : (
              <LoadingText className="d-inline-flex" />
            )}
          </span>
          <span> تومان</span>
        </div>
      </div>
    </SuggestionBoxStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestSuggestionPrice: selectNewRequestSuggestionPrice,
  selectNewRequestSuggestionPriceIsLoading: selectNewRequestSuggestionPriceIsLoading,
});

export default connect(mapStateToProps)(SuggestionBox);
